export default "__VITE_ASSET__DpAqXd6u__"